import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectRoomArea = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('room_area')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
